"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M5 9h14v6H5zm6-7h2v3h-2zm6.2865 4.3988 1.7896-1.8024 1.4193 1.4092-1.7897 1.8024zM11 19h2v3h-2zm6.29-1.29 1.79 1.8 1.42-1.42-1.8-1.79zM3.4948 6.0091 4.9019 4.602l1.789 1.789-1.4071 1.407zm-.0027 12.0671 1.8024-1.7896 1.4092 1.4192-1.8024 1.7897z"
}), 'FluorescentSharp');